import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'stretch',
    background: theme.palette.background.main
  }
}), { name: 'MuiGlueTabletRoot' })

const TabletRoot = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {props.children}
    </div>
  )
}

export default TabletRoot
